export default {
    'username': 'اسم المستخدم',
    'password': 'كلمة المرور',
    'sign-in': 'تسجيل الدخول',
    'select-financial-file': 'اختر الملف المالي',
    'show-financial-file': 'استعراض محتويات الملف',
}